import React from "react";

const LinkedinBrand1 = ({ width = 32, height = 32 }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_3329_131581)">
      <path
        d="M27.6364 0H4.36364C1.95367 0 0 1.95367 0 4.36364V27.6364C0 30.0463 1.95367 32 4.36364 32H27.6364C30.0463 32 32 30.0463 32 27.6364V4.36364C32 1.95367 30.0463 0 27.6364 0Z"
        fill="#0077B5"
      />
      <path
        d="M11.5268 8.72727C11.5268 9.26668 11.3669 9.79397 11.0672 10.2425C10.7675 10.691 10.3416 11.0405 9.84322 11.2469C9.34488 11.4534 8.79651 11.5074 8.26748 11.4021C7.73844 11.2969 7.25248 11.0372 6.87107 10.6557C6.48965 10.2743 6.2299 9.78838 6.12467 9.25934C6.01944 8.7303 6.07345 8.18193 6.27987 7.68359C6.48629 7.18525 6.83585 6.7593 7.28435 6.45963C7.73285 6.15995 8.26014 6 8.79954 6C9.52286 6 10.2166 6.28734 10.728 6.7988C11.2395 7.31026 11.5268 8.00395 11.5268 8.72727Z"
        fill="white"
      />
      <path
        d="M10.9091 13.2727V25.3218C10.9095 25.4107 10.8924 25.4988 10.8588 25.581C10.8251 25.6633 10.7755 25.7381 10.7128 25.8011C10.6501 25.8641 10.5756 25.9141 10.4935 25.9483C10.4114 25.9824 10.3234 26 10.2345 26H7.35996C7.27107 26.0002 7.18301 25.9829 7.10084 25.949C7.01868 25.915 6.94402 25.8652 6.88116 25.8024C6.81831 25.7395 6.7685 25.6649 6.73459 25.5827C6.70069 25.5005 6.68336 25.4125 6.6836 25.3236V13.2727C6.6836 13.0933 6.75486 12.9213 6.8817 12.7944C7.00854 12.6676 7.18058 12.5963 7.35996 12.5963H10.2345C10.4136 12.5968 10.5851 12.6683 10.7116 12.7951C10.838 12.9218 10.9091 13.0936 10.9091 13.2727Z"
        fill="white"
      />
      <path
        d="M25.9343 19.5455V25.3782C25.9346 25.4599 25.9186 25.5409 25.8875 25.6164C25.8563 25.692 25.8105 25.7606 25.7527 25.8184C25.6949 25.8762 25.6263 25.922 25.5507 25.9532C25.4752 25.9843 25.3942 26.0002 25.3125 26H22.2216C22.1399 26.0002 22.0589 25.9843 21.9833 25.9532C21.9078 25.922 21.8392 25.8762 21.7814 25.8184C21.7236 25.7606 21.6778 25.692 21.6466 25.6164C21.6155 25.5409 21.5995 25.4599 21.5998 25.3782V19.7255C21.5998 18.8818 21.847 16.0309 19.3943 16.0309C17.4943 16.0309 17.107 17.9818 17.0307 18.8582V25.3782C17.0307 25.5415 16.9664 25.6983 16.8518 25.8147C16.7371 25.931 16.5813 25.9976 16.418 26H13.4325C13.3509 26 13.2702 25.9839 13.1948 25.9526C13.1195 25.9214 13.051 25.8755 12.9935 25.8178C12.9359 25.76 12.8902 25.6914 12.8592 25.616C12.8281 25.5406 12.8123 25.4598 12.8125 25.3782V13.22C12.8123 13.1384 12.8281 13.0576 12.8592 12.9822C12.8902 12.9067 12.9359 12.8382 12.9935 12.7804C13.051 12.7227 13.1195 12.6768 13.1948 12.6455C13.2702 12.6143 13.3509 12.5982 13.4325 12.5982H16.418C16.5829 12.5982 16.741 12.6637 16.8576 12.7803C16.9743 12.8969 17.0398 13.0551 17.0398 13.22V14.2709C17.7452 13.2127 18.7907 12.3964 21.0216 12.3964C25.9634 12.3964 25.9343 17.0109 25.9343 19.5455Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_3329_131581">
        <rect width="32" height="32" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default LinkedinBrand1;
